<script>
    import ConfirmModal from "./ConfirmModal.svelte";
    import TokenDetails from "../snippets/TokenDetails.svelte";
    import {writable} from "svelte/store";
    import {eventBridge, portalConfiguration} from "../../stores.js";
    import { createEventDispatcher } from 'svelte';

    export let showConfirm = writable(false);
    export let token;
    
    const dispatch = createEventDispatcher();

    const handleDeleteConfirm = () => {
        $eventBridge.dispatchEvent('cs:removeTokenFromCache', {
            tokenId: token.fingerprint
        });
        dispatch('tokenDeletion');
        showConfirm.set(false);
    }

    const handleDeleteCancel = () => {
        showConfirm.set(false);
    }
</script>

<ConfirmModal
        {...$$restProps}
        cancelLabel="Abbrechen"
        header="Zertifikat löschen"
        helpUrl="{$portalConfiguration.help ?? ''}/einrichtung-von-bea/organisatorische-und-technische-voraussetzungen/loeschung-software-token"
        on:cancel={handleDeleteCancel}
        on:confirm={handleDeleteConfirm}
        scrollable
        {showConfirm}
        size="xl"
>
    Möchten Sie das nachfolgende Software-Token wirklich löschen?
    {#if ($showConfirm)}
        <TokenDetails {token} />
    {/if}
</ConfirmModal>